export interface Input extends Marko.HTML.Div {
  isMapExpanded?: boolean;
  "on-cta-click": () => void;
}

export default class extends Marko.Component<Input> {
  onCtaClick() {
    this.emit("cta-click");
  }
}
